import { useEffect, useRef } from "react";
import { main, SpaceInvadersHandle } from "../projects/space_invaders/main";

const canvasStyle: React.CSSProperties = {
  borderRadius: "10px",
  backgroundColor: "black",
  maxWidth: "100%",
  touchAction: "none",
};

const SpaceInvadersPage = () => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const handleRef = useRef<SpaceInvadersHandle | null>(null);

  useEffect(() => {
    if (canvasRef.current) {
      handleRef.current = main(canvasRef.current);
    }
    return () => {
      handleRef.current?.stop();
      handleRef.current = null;
    };
  }, []);

  const hold = (action: (active: boolean) => void) => ({
    onPointerDown: (e: React.PointerEvent) => {
      e.preventDefault();
      action(true);
    },
    onPointerUp: () => action(false),
    onPointerLeave: () => action(false),
    onPointerCancel: () => action(false),
  });

  return (
    <div className="page-content center">
      <h1 hidden>Space Invaders</h1>
      <p style={{ textAlign: "center", marginBottom: "2rem", maxWidth: "600px" }}>
        A classic Space Invaders clone built with the Canvas 2D API. Move with the
        arrow keys (or A / D) and fire with Space. On touch devices, use the buttons
        below.
      </p>
      <canvas style={canvasStyle} ref={canvasRef} />

    </div>
  );
};

export default SpaceInvadersPage;
